export function compareVersions(v1, v2) {
  const splitV1 = v1.split('.').map(Number);
  const splitV2 = v2.split('.').map(Number);

  for (let i = 0; i < 3; i++) {
    const num1 = splitV1[i] || 0;
    const num2 = splitV2[i] || 0;
    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }

  return 0;
}
